export default "<router-outlet></router-outlet> <app-spinner></app-spinner>\n";